import { useMemo } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import { extractInfoFromInfiniteData, extractListRecords } from "../utils";
import { handleGetPopularGames } from "../../api-clients/gamesClient";

interface UseInfinitePopularGamesQueryParams {
  enabled?: boolean;
  limit?: number;
  maxPages?: number;
}

function useInfinitePopularGamesQuery(
  params?: UseInfinitePopularGamesQueryParams
) {
  const { enabled, limit, maxPages } = params || {};

  const query = useInfiniteQuery({
    queryKey: [QUERY_KEYS.GAME.POPULAR_GAMES, { limit, maxPages }],
    queryFn: ({ pageParam }) =>
      handleGetPopularGames({ page: pageParam, limit }),
    initialPageParam: 1,
    maxPages,
    getNextPageParam: (lastPage) => lastPage.nextPage,
    getPreviousPageParam: (firstPage) => firstPage.previousPage,
    enabled,
  });

  const popularGamesList = useMemo(
    () => extractInfoFromInfiniteData(query.data),
    [query.data]
  );

  const popularGames = useMemo(
    () => extractListRecords(popularGamesList),
    [popularGamesList]
  );

  return { query, popularGames };
}

export default useInfinitePopularGamesQuery;
